<template>
    <v-container fluid class="pa-0" style="background: #f9f9f9;">
  
      <!-- App Bar -->
      <v-app-bar dark flat style="background-color: #800000;">
  <v-toolbar-title>Admin Search</v-toolbar-title>
</v-app-bar>

  
      <!-- Search Bar -->
      <v-container>
        <v-row justify="center" class="mt-6">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="searchText"
              label="Search Members"
              outlined
              dense
              clearable
              hide-details
              rounded
              prepend-inner-icon="mdi-magnify"
              @input="filterMembers"
            />
          </v-col>
        </v-row>
  
        <!-- Loading Spinner -->
        <v-row v-if="isLoading" justify="center" class="my-16">
          <v-col cols="auto">
            <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
          </v-col>
        </v-row>
  
        <!-- Member List -->
        <v-row v-else-if="filteredMembers.length > 0" class="px-4">
          <v-col
            v-for="user in filteredMembers"
            :key="user.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="mb-6"
          >
            <v-hover v-slot="{ isHovering, props }">
              <v-card
                v-bind="props"
                :elevation="isHovering ? 12 : 4"
                class="transition-swing pa-2"
                outlined
                style="border-radius: 20px;"
              >
                <v-img
                  :src="user.image || defaultImage"
                  height="200"
                  alt="User Image"
                  class="rounded-lg"
                  cover
                ></v-img>
  
                <v-card-title class="font-weight-bold text-center">
                  {{ user.fullName }}
                </v-card-title>
  
                <v-card-subtitle class="text-center text--secondary">
                  {{ user.title || 'Member' }}
                </v-card-subtitle>
  
                <v-divider class="my-2"></v-divider>
  
                <v-card-actions class="justify-center">
                  <v-btn color="primary" text rounded @click="viewUserDetails(user)">
                    View Profile
                  </v-btn>
                </v-card-actions>
  
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
  
        <!-- No Results -->
        <v-row v-else justify="center" align="center" class="my-16">
          <v-col cols="auto" class="text-center">
            <v-icon color="grey" size="70">mdi-account-search-outline</v-icon>
            <p class="text-grey--text mt-2">No members found matching your search.</p>
          </v-col>
        </v-row>
      </v-container>
  
      <!-- Bottom Navigation for Ministers -->
      <v-bottom-navigation app grow>
        <v-btn icon to="/admin-home">
          <span>
            <v-icon>mdi-home</v-icon>
            <p class="tab-label">Home</p>
          </span>
        </v-btn>
        <v-btn icon to="/admin-search">
          <span>
            <v-icon>mdi-magnify</v-icon>
            <p class="tab-label">Search</p>
          </span>
        </v-btn>
        <v-btn icon to="/minister-messages">
          <span>
            <v-icon>mdi-message-text-outline</v-icon>
            <p class="tab-label">Messages</p>
          </span>
        </v-btn>
        <v-btn icon to="/minister-prayer-requests">
          <span>
            <v-icon>mdi-hands-pray</v-icon>
            <p class="tab-label">Prayer</p>
          </span>
        </v-btn>
        <v-btn icon to="/admin-settings">
          <span>
            <v-icon>mdi-cog</v-icon>
            <p class="tab-label">Settings</p>
          </span>
        </v-btn>
      </v-bottom-navigation>
  
    </v-container>
  </template>
  
  <script>
  import { collection, getDocs } from "firebase/firestore";
  import { db } from "@/firebase";
  
  export default {
    name: "AdminSearchView",
    data() {
      return {
        searchText: "",
        members: [],
        filteredMembers: [],
        isLoading: true,
        defaultImage: require("@/assets/logo.png"),
      };
    },
    methods: {
      async fetchMembers() {
        this.isLoading = true;
        try {
          const membersRef = collection(db, "user");
          const snapshot = await getDocs(membersRef);
          this.members = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.filterMembers();
        } catch (error) {
          console.error("Error fetching members:", error);
        } finally {
          this.isLoading = false;
        }
      },
      filterMembers() {
        const searchTextLower = this.searchText.toLowerCase();
        this.filteredMembers = this.members.filter(
          (member) =>
            (member.fullName && member.fullName.toLowerCase().includes(searchTextLower)) ||
            (member.title && member.title.toLowerCase().includes(searchTextLower))
        );
      },
      viewUserDetails(user) {
        this.$router.push({ name: "MemberDetail", params: { id: user.id } });
      },
    },
    async mounted() {
      await this.fetchMembers();
    },
  };
  </script>
  
  <style scoped>
  .transition-swing {
    transition: 0.3s;
  }
  .tab-label {
    font-size: 10px;
    margin-top: 2px;
    color: grey;
  }
  </style>  